























import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'ProductionPC'
})
export default class extends Vue {
  showNav = true
}
